export default __webpack_public_path__ + "static/media/GarretCree.63f2f048.jpg";